import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Closewell',
    description: 'Closewell is the AI transaction coordinator for real estate teams. It tracks every deadline, chases every signature and keeps every party updated, from accepted offer to closing day.',
    url: getOrigin(),
    ogImage: 'https://oriel.cdn.modulify.website/share/oriel-social.jpg'
}
